import React, {Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import WOW from 'wowjs';
import Header from './../Layout/Header';
import FooterPremium from './../Layout/FooterPremium';
import PageTitle from './../Layout/PageTitle';

// Images
import banner3 from './../../images/banner/TowerC.jpg';
import banner4 from './../../images/about/cd.png';
import ban1 from './../../images/about/towerd.png';

const ongoingProjects = [
	{
		id: 1,
		name: "Goldcrest Dreams Tower C",
		image: banner3,
		status: "Under Construction",
		statusColor: "#ffc107",
		link: "/goldcrest-dream-tower-c",
		features: [
			"Currently under construction",
			"Planned with modern design",
			"Contemporary living spaces focusing on innovation and sustainability",
			"Range of amenities"
		]
	},
	{
		id: 2,
		name: "Goldcrest Dreams Tower D",
		image: ban1,
		status: "Coming Soon",
		statusColor: "#17a2b8",
		link: "/contact-us",
		features: [
			"New development",
			"Comfortable and luxurious living spaces",
			"Focus on innovation and sustainable design",
			"Luxurious living experience with modern amenities"
		]
	}
];

class OngoingProjects extends Component{
	componentDidMount(){
		new WOW.WOW().init();
	}
	
	render(){
		return(
			<Fragment>
				<style>{`
					.projects-hero-section {
						padding: 100px 0 80px;
						background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
					}
					.projects-hero-title {
						font-size: 35px;
						font-weight: 800;
						color: #1a1a1a;
						line-height: 1.2;
						margin-bottom: 25px;
						letter-spacing: -1px;
					}
					.projects-hero-title span {
						color: #b8975f;
					}
					.projects-hero-text {
						font-size: 18px;
						line-height: 1.8;
						color: #666;
						margin-bottom: 0;
					}
					.projects-feature-card {
						display: flex;
						align-items: center;
						padding: 15px;
						background: #fff;
						border-radius: 10px;
						box-shadow: 0 2px 10px rgba(0,0,0,0.05);
						margin-bottom: 15px;
					}
					.projects-feature-icon {
						width: 50px;
						height: 50px;
						border-radius: 50%;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-right: 15px;
						flex-shrink: 0;
					}
					.projects-feature-icon.green {
						background: linear-gradient(135deg, #000000 0%, #a5895a 100%);
					}
					.projects-feature-icon.orange {
						background: linear-gradient(135deg, #000000 0%, #a5895a 100%);
					}
					.projects-feature-icon.blue {
						background: linear-gradient(135deg, #000000 0%, #a5895a 100%);
					}
					.projects-feature-icon i {
						color: #fff;
						font-size: 20px;
					}
					.projects-feature-text {
						font-size: 16px;
						color: #333;
						font-weight: 600;
					}
					.projects-hero-image-wrapper {
						position: relative;
						overflow: hidden;
						border-radius: 15px;
						box-shadow: 0 10px 30px rgba(0,0,0,0.15);
						transition: transform 0.3s ease;
					}
					.projects-hero-image-wrapper:hover {
						transform: translateY(-5px);
					}
					.projects-hero-image-row {
						width: 100%;
						justify-content: center;
						align-items: center;
						min-height: 320px;
					}
					.projects-hero-image-wrapper.projects-hero-image-single {
						width: 100%;
						max-width: 540px;
						margin: 0 auto;
					}
					.projects-hero-image.projects-hero-image-large {
						height: 340px;
					}
					@media (max-width: 991.98px) {
						.projects-hero-image-row {
							min-height: auto;
						}
						.projects-hero-image.projects-hero-image-large {
							height: 260px;
						}
					}
					.projects-hero-image {
						width: 100%;
						height: 220px;
						object-fit: cover;
						display: block;
					}
					.projects-section-title {
						font-size: 42px;
						font-weight: 800;
						color: #1a1a1a;
						margin-bottom: 15px;
						letter-spacing: -1px;
					}
					.projects-section-title span {
						color: #b8975f;
					}
					.projects-section-subtitle {
						font-size: 18px;
						color: #666;
						max-width: 700px;
						margin: 0 auto;
					}
					.projects-grid-section {
						padding: 80px 0;
						background: #fff;
					}
					.projects-card {
						background: #fff;
						border-radius: 10px;
						overflow: hidden;
						box-shadow: 0 5px 25px rgba(0,0,0,0.08);
						transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
						height: 100%;
						display: flex;
						flex-direction: column;
					}
					.projects-card:hover {
						transform: translateY(-10px);
						box-shadow: 0 15px 40px rgba(0,0,0,0.15);
					}
					.projects-card-image-container {
						position: relative;
						overflow: hidden;
						height: 320px;
						background: #f0f0f0;
					}
					.projects-card-image {
						width: 100%;
						height: 100%;
						object-fit: cover;
						transition: transform 0.5s ease;
					}
					.projects-card:hover .projects-card-image {
						transform: scale(1.1);
					}
					.projects-image-overlay {
						position: absolute;
						bottom: 0;
						left: 0;
						right: 0;
						height: 100px;
						background: linear-gradient(to top, rgba(0,0,0,0.6), transparent);
					}
					.projects-card-content {
						padding: 15px;
						flex: 1;
						display: flex;
						flex-direction: column;
					}
					.projects-card-title {
						font-size: 28px;
						font-weight: 700;
						color: #1a1a1a;
						margin-bottom: 7px;
						line-height: 1.3;
					}
					.projects-card-features {
						list-style: none;
						padding: 0;
						margin-bottom: 25px;
						flex: 1;
					}
					.projects-card-features li {
						margin-bottom: 12px;
						font-size: 15px;
						color: #555;
						display: flex;
						align-items: flex-start;
						line-height: 1.6;
					}
					.projects-card-features li i {
						color: #b8975f;
						margin-right: 12px;
						margin-top: 3px;
						font-size: 16px;
						flex-shrink: 0;
					}
					.projects-card-button {
						display: inline-block;
						width: 100%;
						text-align: center;
						background: linear-gradient(135deg, #656565 0%, #000000 100%);
						color: #fff;
						padding: 14px 30px;
						border-radius: 10px;
						font-weight: 700;
						font-size: 16px;
						text-decoration: none;
						transition: all 0.3s ease;
						box-shadow: 0 4px 15px rgb(86 86 86);
						border: none;
						text-transform: uppercase;
						letter-spacing: 0.5px;
					}
					.projects-card-button:hover {
						transform: translateY(-2px);
						box-shadow: 0 6px 20px rgba(227, 144, 1, 0.4);
						color: #fff;
						text-decoration: none;
					}
				`}</style>
				<Header />
				<div className="page-content bg-white">
					<PageTitle motherMenu="Ongoing Projects" activeMenu="Ongoing Projects" />
					
					{/* Hero Section */}
					<section className="content-inner projects-hero-section">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-lg-6 mb-5 mb-lg-0">
									<div className="wow fadeInLeft" data-wow-duration="1s">
										<h2 className="projects-hero-title">
											OUR <span>ONGOING PROJECTS</span> — WHERE TOMORROW TAKES SHAPE
										</h2>
										<p className="projects-hero-text">
											Our ongoing portfolio reflects the next chapter of Star Giga - projects that are actively progressing with modern architecture, quality construction, and future-ready amenities. From under-construction developments to upcoming launches, each project is planned to deliver long-term value, comfort, and a premium lifestyle for residents and investors.
										</p>
									</div>
								</div>
								<div className="col-lg-6 d-flex align-items-center justify-content-center">
									<div className="row wow fadeInRight projects-hero-image-row" data-wow-duration="1s">
										<div className="col-12">
											<div className="projects-hero-image-wrapper projects-hero-image-single">
												<img src={banner4} alt="Goldcrest Dreams Tower C" className="projects-hero-image projects-hero-image-large" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* Projects Grid Section */}
					<section className="content-inner projects-grid-section">
						<div className="container">
							<div className="row mb-5">
								<div className="col-12 text-center">
									<h2 className="projects-section-title">
										Our <span>Ongoing Projects</span>
									</h2>
									<p className="projects-section-subtitle">
										Explore our developments currently under construction and coming soon—designed for modern living.
									</p>
								</div>
							</div>
							
							<div className="row">
								{ongoingProjects.map((project, index) => (
									<div key={project.id} className="col-lg-6 col-md-6 mb-4">
										<div className="wow fadeInUp" data-wow-delay={`${index * 0.1}s`}>
											<div className="projects-card">
												<div className="projects-card-image-container">
													<img 
														src={project.image} 
														alt={project.name}
														className="projects-card-image"
													/>
													<div className="projects-image-overlay"></div>
												</div>
												
												<div className="projects-card-content">
													<h3 className="projects-card-title">
														{project.name}
													</h3>
													
													<ul className="projects-card-features">
														{project.features.map((feature, idx) => (
															<li key={idx}>
																<i className="fa fa-check-circle"></i>
																<span>{feature}</span>
															</li>
														))}
													</ul>
													
													<Link 
														to={project.link}
														className="projects-card-button"
													>
														View Details <i className="fa fa-arrow-right ml-2"></i>
													</Link>
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</section>
				</div>
				<FooterPremium />
			</Fragment>
		)
	}
}

export default OngoingProjects;
